import React from "react";
//import logo from "../../../../public/images/pranaam-365-logo.png";
import { Bell } from "lucide-react";
import { Link, useLocation } from "react-router-dom";

function ReportsHeader({ toggleSidebar, handleLogout }) {
  return (
    <header className="header">
      <div className="logo-container">
        {/* <button className="menu-toggle" onClick={toggleSidebar}>
          <span></span>
          <span></span>
          <span></span>
        </button> */}
        <Link to="/" >
          <img src="/images/pranaam-365-logo.png" alt="Pranaam Hospitals" className="logo" />
        </Link>
      </div>
      <div className="header-actions">
        <button className="icon-button">
          <Bell />
        </button>
        <div className="user-profile" onClick={handleLogout} title="Logout">
          JD
        </div>
      </div>
    </header>
  );
}

export default ReportsHeader;
